import type { CalendarViewMode } from '@/modules/calendar/types';
import { formatIsoDate, formatMonthYear } from '@/modules/calendar/utils';

type CalendarToolbarProps = {
  view: CalendarViewMode;
  anchorDate: string;
  onViewChange: (view: CalendarViewMode) => void;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
};

const VIEW_LABELS: Record<CalendarViewMode, string> = {
  month: 'Mes',
  week: 'Semana',
  day: 'Día',
};

export function CalendarToolbar({
  view,
  anchorDate,
  onViewChange,
  onPrev,
  onNext,
  onToday,
}: CalendarToolbarProps) {
  const title =
    view === 'month'
      ? formatMonthYear(anchorDate)
      : view === 'week'
        ? `Semana del ${formatIsoDate(anchorDate)}`
        : formatIsoDate(anchorDate);

  return (
    <div className="calendar-toolbar">
      <div className="calendar-toolbar__nav">
        <button type="button" className="users-tab" onClick={onPrev} aria-label="Anterior">
          ‹
        </button>
        <button type="button" className="users-tab" onClick={onToday}>
          Hoy
        </button>
        <button type="button" className="users-tab" onClick={onNext} aria-label="Siguiente">
          ›
        </button>
        <h2 className="calendar-toolbar__title">{title}</h2>
      </div>
      <div className="users-tabs" role="tablist">
        {(Object.keys(VIEW_LABELS) as CalendarViewMode[]).map((mode) => (
          <button
            key={mode}
            type="button"
            role="tab"
            className={view === mode ? 'users-tab is-active' : 'users-tab'}
            onClick={() => onViewChange(mode)}
          >
            {VIEW_LABELS[mode]}
          </button>
        ))}
      </div>
    </div>
  );
}
